import { DocsContainer } from '../../../containers/DocsContainer'

const Docs = () => {
  return <DocsContainer />
}

export default Docs
